// ABOUTME: Router component for legacy-market space with Azure AD B2C configuration
// ABOUTME: Handles routing and authentication for legacy market features with grayscale styling
import { Routes, Route, useNavigate } from "react-router-dom";

// MSAL imports
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { CustomNavigationClient } from "../utils/NavigationClient";

// Sample app imports
import { LegacyHome } from "../pages/LegacyHome";
import { Profile } from "../pages/Profile";
import { AlertCircle } from "lucide-react";

type LegacyMarketRouterProps = {
    pca: IPublicClientApplication;
};

export function LegacyMarketRouter({ pca }: LegacyMarketRouterProps) {
    const navigate = useNavigate();
    const navigationClient = new CustomNavigationClient(navigate);
    pca.setNavigationClient(navigationClient);

    return (
        <MsalProvider instance={pca}>
            {/* Legacy grayscale styling wrapper */}
            <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-black grayscale">
                {/* Old system grid pattern */}
                <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXR0ZXJuIGlkPSJncmlkIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiPjxwYXRoIGQ9Ik0gODAgMCBMIDAgMCAwIDgwIiBmaWxsPSJub25lIiBzdHJva2U9IiM0NDQ0NDQiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIiAvPjwvc3ZnPg==')] opacity-20"></div>

                <div className="relative z-10">
                    {/* Legacy System Banner */}
                    <div className="border-b border-gray-700 bg-black/50 backdrop-blur-sm">
                        <div className="container mx-auto px-4 py-4">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center">
                                    <AlertCircle className="w-5 h-5 text-gray-400 mr-2" />
                                    <span className="text-gray-300 font-mono text-sm">LEGACY MARKET - Azure AD B2C</span>
                                </div>
                                <div className="bg-gray-800 px-3 py-1 rounded border border-gray-600">
                                    <span className="text-gray-400 font-mono text-xs">OLD SYSTEM</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="container mx-auto px-4 py-8">
                        <Routes>
                            <Route path="/profile" element={<Profile />} />
                            <Route path="/" element={<LegacyHome />} />
                        </Routes>
                    </div>
                </div>
            </div>
        </MsalProvider>
    );
}
